export const esPostFechaLimite = (): boolean => {
  const fechaActual = new Date()
  const fechaLimite = new Date("2026-01-01")
  return fechaActual >= fechaLimite
}

export const configuracionRequeridaMessage = (
  <>
    La conexión con Verifactu se activará el{" "}
    <span className='fs-font-medium'>1 de enero de 2026</span>. Para asegurar el
    cumplimiento normativo, por favor configura la{" "}
    <span className='fs-font-medium'>Ley Antifraude</span> en tu empresa antes
    de finalizar el año.
  </>
)

export const configuracionRequeridaDefinitivoMessage = (
  <>
    Para cumplir con la normativa vigente, debe configurar la{" "}
    <span className='fs-font-medium'>Ley antifraude</span> desde su perfil de
    empresa antes de poder generar o gestionar nuevos documentos.
  </>
)
